import { computed, defineComponent, PropType, ref, toRefs } from 'vue';

interface SdRadioData {
    text: string;
    value: number;
}

export default defineComponent({
    name: 'SdRadio',
    props: {
      modelValue: {
        type: [Object, String, Number, Boolean] as PropType<any>,
        default: null,
      },
      options:{
        type: [Array, Object] as PropType<any | SdRadioData[]>,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
      },
      required: {
        type: Boolean,
        required: false,
      },
      disabled: {
        type: Boolean,
        required: false,
      },
      submitted: {
        type: Boolean,
        required: false,
      },
      positionItem: {
        type: String,
        required: false,
      },
    },
    emits:['update:modelValue'],
    setup(props, { emit }) {
        const dirty = ref(false);
        const radio = ref<HTMLFormElement | null>(null);
        const content = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                const newValue = isNaN(value) ? value : Number(value);
                emit('update:modelValue', newValue);
                dirty.value = true;
                radio.value?.classList.remove('error');
            }
        });

        const isRequired = computed(() => {
           return props.required && (props.submitted || dirty.value) && props.modelValue == null;
        });

        return {
          ...toRefs(props),
            radio,
            content,
            isRequired,
            dirty
        };
    }
})

